import classnames from 'classnames';
import React from 'react';
import './_section.scss';

var Section = function Section(props) {
  var backgroundImageStyle = props.backgroundImage && {
    backgroundImage: "url(\"" + props.backgroundImage + "\")",
    backgroundPosition: props.backgroundPosition
  };
  var shadedOverlay = props.backgroundShaded && /*#__PURE__*/React.createElement("div", {
    className: "section__shaded-overlay"
  });
  var shadedfooter = /*#__PURE__*/React.createElement("div", {
    className: "section__shaded-footer"
  }, /*#__PURE__*/React.createElement("img", {
    src: require('./images/shadow.svg'),
    alt: ""
  }));
  var className = classnames('section', {
    'section--squashed': props.squashed
  }, props.className);
  return /*#__PURE__*/React.createElement("section", {
    id: props.id,
    className: className,
    style: backgroundImageStyle
  }, shadedOverlay, /*#__PURE__*/React.createElement("div", {
    className: "container section__content"
  }, className.indexOf('hero') === -1 && props.heading && /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, props.heading), props.children), props.hasFooter ? shadedfooter : null);
};

export default Section;